import { Component, Input, OnInit } from '@angular/core';
import { EventEmitterService } from 'src/app/core/services/v2/event-emitter.service';
import { Router } from '@angular/router';
import { SideBarInitializeParameters } from 'src/app/shared/components/dynamic-right-sidebar/SideBarInitializeParameters';
import { SupportRequestComponent } from 'src/app/shared/components/SupportRequest/SupportRequest.component';
import { CommonService } from 'src/app/core/services/v2/common.service';

@Component({
  selector: 'app-layout-sidebar',
  templateUrl: './layout-sidebar.component.html',
  styleUrls: ['./layout-sidebar.component.scss']
})
export class LayoutSidebarComponent implements OnInit {
  @Input() isExpandNav: boolean;

  constructor(private eventEmitterService: EventEmitterService, private route:Router,
    private commonService: CommonService
  ) { }

  ngOnInit() {
  }
  //goTomarketPlace() {
  //  this.route.navigate(['/patient/marketplace']).then(() => {
  //  })
  //}

  openSupportRequest() {
    const supportRequest = <SideBarInitializeParameters> {
      componentType: SupportRequestComponent
    };

    this.commonService.rightSideBarComponent$.next(supportRequest);
  }
}
